import styled from "styled-components";

export const TabsWrapper = styled.div`
  button {
    padding: 25px 25px;
    border: none;
    background-color: transparent;
    color: #fff;
    cursor: pointer;   
    line-height: 18px;
    font-weight: 600;
    &.active {
      border-radius: 5px;
      background-color: #FFFF;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.17);
      color: #4f4f4f;
    }
  }
`;

export const Wrapper = styled.div`
  .tab-container{
    background: #fff;
    padding: 24px;
    border-radius: 10px;
  }
  .gGmhQv {
    padding: 49px 25px;
  }
  .form-wrapper {
    border-radius: 5px;
    background-color: #f7f8f9;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 17%);
    padding: 49px 52px;
    margin-top: -8px;
    position: relative;
  }
  .form-inner {
    max-width: 78%;
  }
  a {
    font-size: 15px;
    color: #005aa3;
  }
  .wd50 {
    width: calc(50% - 14px);
  }
  .bgWhite {
    background-color: #fff;
  }
  .Group {
    padding: 12px 20px;
    border-radius: 4px;
    span {
      background-color: #f7f8f9;
      padding: 5px 6px;
      margin-right: 6px;
      border-radius: 4px;
      color: #4f4f4f;
    }
  }
  .icon-attachment {
    max-width: 20px;
    display: flex;
    align-items: center;
    img {
      max-width: 100%;
    }
  }
  .refresh-button{
    display: block;
  }

  /* MCC List Styles */
  .mcc-type-selector {
    padding: 16px 0;
  }
  
  .type-button {
    padding: 10px 20px;
    border: 2px solid #ddd;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
      background-color: #f0f3f4;
    }
    
    &.active {
      border-radius: 8px;
      background-color: #ED141F;
      color: #fff;
    }
  }
  
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
  }
  
  .loading-spinner {
    font-size: 16px;
    color: #666;
  }
  
  .mcc-list-container {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
  }
  
  .mcc-list-header {
    display: grid;
    background: #f8f9fa;
    padding: 16px;
    font-weight: bold;
    border-bottom: 1px solid #e0e0e0;
    gap: 16px;
  }
  
  .mcc-list-scrollable {
    max-height: 500px;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }
  
  .mcc-list-item {
    display: grid;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
    gap: 16px;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: #f8f9fa;
    }
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  .header-item, .list-item {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .list-item {
    font-size: 14px;
    line-height: 1.4;
    color: #4f4f4f;
  }
  
  .empty-state {
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 16px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
  }

  /* Utility classes */
  .flex {
    display: flex;
  }
  
  .flex-center {
    align-items: center;
  }
  
  .space-between {
    justify-content: space-between;
  }
  
  .gap16 {
    gap: 16px;
  }
  
  .mb10 {
    margin-bottom: 10px;
  }
  
  .mb20 {
    margin-bottom: 20px;
  }
  
  .mt32 {
    margin-top: 32px;
  }

  .download-button-container {
    margin-top: 20px;
  }
`;